import { FilterComponent } from './tag/filters';
import InfinityScroll from '../components/infinityScroll';
import setTopBar from '../components/topBar.js';
import setCategoriesSlider from './tag/categories_slider.js';

const Tag = {
  init: function () {
    setTopBar();
    setCategoriesSlider();
    FilterComponent.init();
    InfinityScroll.init();
    this.setDescriptionDropdown();
  },

  setDescriptionDropdown: function () {
    const dropdowns = document.querySelectorAll('[data-dropdown]');

    dropdowns.forEach((dropdown) => {
      const trigger = dropdown.querySelector('[data-dropdown-trigger]');
      if (!trigger) return;

      trigger.addEventListener('click', () => {
        dropdown.classList.toggle('-active');
      });
    });
  },
};

window.addEventListener('DOMContentLoaded', () => {
  Tag.init();
});
